import React, { MouseEvent, SyntheticEvent } from 'react';
import { withPrefix } from 'gatsby-link';
import { Button, ButtonSizes, ButtonStyles, ScreenBasedImage, Text } from '@quantum/ui-atoms';
import * as styles from './styles.module.scss';

export interface ErrorTemplateProps {
  header: string;
  description: string;
  ctaText: string;
  onRetry: (event: MouseEvent<HTMLAnchorElement> | SyntheticEvent<HTMLButtonElement>) => void;
}

const desktopImage = {
  srcSet: `${withPrefix('/images/house-538-2x.png')} 2x,\n${withPrefix('/images/house-538-1x.png')} 1x`,
  src: `${withPrefix('/images/house-538-1x.png')}`,
  srcWebp: '',
  srcSetWebp: '',
  contentType: 'image/png',
};

const tabletImage = {
  srcSet: `${withPrefix('/images/house-448-2x.png')} 2x,\n${withPrefix('images/house-448-1x.png')} 1x`,
  src: `${withPrefix('/images/house-448-1x.png')}`,
  srcWebp: '',
  srcSetWebp: '',
  contentType: 'image/png',
};

const mobileImage = {
  srcSet: `${withPrefix('/images/house-343-2x.png')} 2x,\n${withPrefix('images/house-343-1x.png')} 1x`,
  src: `${withPrefix('/images/house-343-1x.png')}`,
  srcWebp: '',
  srcSetWebp: '',
  contentType: 'image/png',
};

export const ErrorTemplate: React.FC<ErrorTemplateProps> = ({ header, description, onRetry, ctaText }) => (
  <div className={styles.root}>
    <ScreenBasedImage
      title='ErrorImg'
      alt='Error Image'
      desktopImage={desktopImage}
      tabletImage={tabletImage}
      mobileImage={mobileImage}
    />
    <Text as='p' className={styles.header}>
      {header}
    </Text>
    <Text as='p' className={styles.description}>
      {description}
    </Text>
    <Button
      animate
      fullWidth
      buttonStyle={ButtonStyles.primary}
      size={ButtonSizes.large}
      text={ctaText}
      onClick={onRetry}
    />
  </div>
);
